import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { Logo } from "@/components/Logo";

export default function About() {
  const [c, setC] = useState({});
  useEffect(() => { api.get("/content").then((r) => setC(r.data)).catch(() => {}); }, []);

  return (
    <div>
      <section className="relative py-20 grain overflow-hidden">
        <img src={c.membership_image || "/assets/membership_jacket.jpg"} alt="" className="absolute inset-0 w-full h-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-[#0c0b0a]/80" />
        <div className="relative z-10 max-w-3xl mx-auto px-5 text-center">
          <Logo className="h-24 mx-auto mb-6" />
          <h1 className="headline text-5xl sm:text-7xl gold-text">I-65 RYDERS</h1>
          <p className="headline text-xl sm:text-2xl text-[#f7f3ec] tracking-[0.15em] mt-2">DIFFERENT TRAILS. SAME FAMILY.</p>
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-5 sm:px-8 py-14 space-y-8">
        <div>
          <p className="eyebrow text-[#e0481f] text-sm mb-2">Who We Are</p>
          <h2 className="headline text-3xl sm:text-4xl text-[#f7f3ec] mb-4">{c.about_title || "MORE THAN A RIDE. IT'S FAMILY."}</h2>
          <p className="text-[#d6cec2] text-lg leading-relaxed">{c.about_text || "ATVs, side-by-sides, horses, motorcycles and custom trucks — we ride it all. But the ride is only half of it. The I-65 Ryders are built on good people, good times and real family."}</p>
        </div>
        <div className="grid sm:grid-cols-3 gap-4">
          {["ATVs & Side-by-Sides", "Horses & Trail Rides", "Motorcycles & Custom Trucks"].map((t) => (
            <div key={t} className="card-warm rounded-2xl p-5">
              <p className="headline text-xl text-[#f3c649]">{t}</p>
            </div>
          ))}
        </div>
        <div className="card-warm rounded-3xl p-8 text-center">
          <h3 className="headline text-3xl text-[#f7f3ec] mb-3">Ready To Ride With Us?</h3>
          <Link to="/join" className="btn-gold rounded-xl px-8 py-4 font-display uppercase tracking-wider text-lg inline-flex items-center gap-2">
            Join The Family <ArrowRight size={20} />
          </Link>
        </div>
      </section>
    </div>
  );
}
